export default "https://assets-v2.scaler.com/packs/images/funnel.6ac58a.svg";